module.exports = __webpack_public_path__ + "img/9d23441.png";